export function assign(obj: any, prop: string, value: any): void {
  obj[prop] = value;
}

export function isSSR(): boolean {
  return typeof window === 'undefined';
}
